import {
  createUserWithEmailAndPassword,
  getAuth,
  signInWithEmailAndPassword,
  signOut
} from 'firebase/auth';
import { AuthenticationHandler } from '../../../domain/contracts/gateways';
import { UserRepository } from '../../../domain/contracts/repositories';
import { SpecialtyCode, User } from '../../../domain/entities';
import { Roles, SystemRole } from '../../../utils';
import { addDoc, collection } from 'firebase/firestore';
import db from '../../../setup/firebase/firebase';

export class FirebaseAuthenticationHandler implements AuthenticationHandler {
  COLLECTION_PATH = 'users';

  constructor(private readonly userRepository: UserRepository) {}

  async loginInWithEmailAndPassword(email: string, password: string): Promise<User> {
    const auth = getAuth();
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const firebaseUser = userCredential.user;
    const user = await this.userRepository.findOne(firebaseUser.uid);
    user.id = firebaseUser.uid;
    return user;
  }

  async logout(): Promise<void> {
    const auth = getAuth();
    await signOut(auth);
  }

  async signup({
    email,
    password
  }: {
    email: string;
    password: string;
  }): Promise<{ userId: string }> {
    const auth = getAuth();
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    return { userId: userCredential.user.uid };
  }
}
